import { render, staticRenderFns } from "./CommentDetails.vue?vue&type=template&id=91018b40&scoped=true&"
import script from "./CommentDetails.vue?vue&type=script&lang=js&"
export * from "./CommentDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommentDetails.vue?vue&type=style&index=0&id=91018b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91018b40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
